import { is_intersect } from "./math_functions.js"

var stats = ['mobility', 'resilience', 'recovery', 'discipline', 'intellect', 'strength', 'class_stat'];

export class Effect_container
{
    constructor(master)
    {
        this.master = master;
        this.commander = this.master.commander;
        this.effects = new Map();
        this.added_effects = new Set();
        this.added_items = new Set();
        this.active_effects = new Set();
        this.conditionally_active = new Set();
        this.conditional_actions_list = new Set();

        this.affecting_cooldowns = new Set();
        this.sorted_by_duration = [];
        this.inf_duration = [];
    }

    add_item(item_id)
    {
        if (item_id == null) return;

        let item = this.get(item_id);

        if (item == null) return;

        this.added_items.add(item_id);

        if (item.type == "class_ability" || item.type == "grenade_ability" || item.type == "melee_ability" || item.type == "super_ability" )
            this.inc_counter(item_id);

        if ("perks" in item && item.perks != null)
        {
            for (let perk_description of item.perks)
            {
                this.inc_counter(perk_description.id);
            }
        }

        this.chain_add(item);
    }

    remove_item(item_id)
    {
        if (item_id == null) return;

        let item = this.get(item_id);

        if (item == null) return

        if (item.type == "class_ability" || item.type == "grenade_ability" || item.type == "melee_ability" || item.type == "super_ability" )
            this.dec_counter(item_id);

        this.added_items.delete(item_id);

        if ("perks" in item && item.perks != null)
        {
            for (let perk_description of item.perks)
            {
                this.dec_counter(perk_description.id);
            }
        }

        this.chain_remove(item);
    }

    /*
    inc_counter()
    every ability has a counter that reflects how many sources granting this ability are present currently
    if counter == 0, ability become deactivated and is removed from the screen
    an example:
    let's assume there are 2 abilities selected and they both grant access to Scorch effect and others do not provide access to Scorch effect
    if we select ability #1, Scorch effect should appear under Active effects              | counter = 1
    if we remove ability #1, Scorch effect should disappear from Active effects colum      | counter = 0
    but if we select both #1 and #2, Scorch effect appears only once                       | counter = 2
    if we remove ability #1, Scorch effect still appears under Active effects              | counter = 1
    if finally remove ability #2 -> Scorch effect disappears from Active effects column    | counter = 0
    */
    inc_counter(effect_id, perk_counter=null)
    {
        if (effect_id == null) return;

        let effect = this.get(effect_id);

        if (effect == null) return;

        effect.counter++;

        console.log("inc_counter() -> added " + effect_id + " counter: " + effect.counter);

        if (effect.activation == 'auto')
            effect.set_stack(effect.counter);

        if (effect.counter == 1) // if effect is just added, before ++ it was 0
        {
            this.added_effects.add(effect);

            if (effect.affect_cooldowns)
                this.affecting_cooldowns.add(effect);

            if (effect.activation == 'auto')
            {
                if (effect.activation_condition != null)
                    this.conditionally_active.add(effect);
                else
                {
                    effect.is_active = true;
                    this.active_effects.add(effect);
                }

                if (effect.active_duration == 'infinite')
                    effect.set_duration(-1); // so if effect is always active -1 means duration is infinite
            }

            if (effect.conditional_actions != null) // move to those that have conditional_actions !== null
                this.conditional_actions_list.add(effect);

            this.chain_add(effect);

            this.commander.update(
                {
                    update_type: "update_insight",
                    effect: effect
                }
            );
        }
    }

     // works in (almost) the same manner as inc_counter, but removes effects
    dec_counter(effect_id, perk_counter=null)
    {
        if (effect_id == null) return;

        let effect = this.get(effect_id);

        if (effect == null) return;

        if (effect.counter > 0) effect.counter--; // decreasing counter
        else return;

        console.log("dec_counter() -> removed " + effect.id + ' counter: ' + effect.counter);

        if (effect.activation == 'auto')
            effect.set_stack(effect.counter);

        if (effect.counter == 0) // if counter == 0 there are no sources for this effect, so deactivating it
        {
            this.added_effects.delete(effect);
            this.active_effects.delete(effect); // if effect was active on deletion

            if (effect.affect_cooldowns)
                this.affecting_cooldowns.delete(effect);

            if (effect.activation_condition != null)
                this.conditionally_active.delete(effect);

            effect.is_active = false;

            this.conditional_actions_list.delete(effect);

            if (effect.conditional_actions !== null) // because this effect was removed from this.conditional_actions_list process_conditional_actions won't have effect, so doing it manually
            {   // but here effects can be only removed
                for (let conditional of effect.conditional_actions)
                {
                    console.log("SET granted_last_round = false")
                    if (conditional.granted_last_round) // if true
                    {
                        conditional.granted_last_round = false;

                        this.undo_conditional_action(conditional);
                    }
                }
            }

            this.chain_remove(effect);

            this.commander.update(
                {
                    update_type: "update_insight",
                    effect: effect
                }
            );
        }
    }

    set_stack(effect_id, stack)
    {
        let effect = this.get(effect_id);

        effect.set_stack(stack);
    }

    set_activity(effect_id, activity)
    {
        let effect = this.get(effect_id);

        effect.set_activity(activity);
    }

    process_conditional_actions()
    {   console.log('APP/EFFECTS: Processing conditional actions');
        console.time('APP/EFFECTS: Processed conditional actions');

        for (let effect of this.conditional_actions_list)
        {
            if (effect.is_active == true) // effect can grant something only if it is active
            {
                for (let conditional of effect.conditional_actions)
                {
                    let checked_condition = this.master.check_condition(conditional.condition);

                    if (checked_condition && !conditional.granted_last_round) // if conditional.granted_last_round == false
                    {
                        conditional.granted_last_round = true;
                        this.do_conditional_action(conditional);
                    } //else -- do nothing it is already granted and already conditional.granted_last_round == true

                    if (checked_condition && conditional.granted_last_round && !this.master.is_action_fulfilled(conditional.action))
                    {
                        // this branch is used for actions that are applied onto category for example:
                        // override grenade_cooldown is such type of action
                        // lets apply such buff
                        // if now we switch grenade the action's granted last round is true,
                        // and condition is fulfilled (because no condition is always true)
                        // but in reality it is not applied
                        // TODO: add condition to such actions, like if_unfulfilled
                        this.do_conditional_action(conditional);
                    }

                    if (!checked_condition && conditional.granted_last_round) // conditional.granted_last_round == true
                    {
                        conditional.granted_last_round = false;
                        this.undo_conditional_action(conditional);
                    } //else -- do nothing, already conditional.granted_last_round == true
                }
            }
        }
        console.timeEnd('APP/EFFECTS: Processed conditional actions');
    }

    do_conditional_action(conditional)
    {
        if (conditional.action.type == 'grant')
        {
            this.inc_counter(conditional.action.grant_effect);
        }
        else if (conditional.action.type == 'override_ability')
        {
            this.master.override_ability(conditional.action.override_target, conditional.action.override_value);
        }
        else if (conditional.action.type == 'override_ability_cooldown')
        {
            console.log('override_ability_cooldown')

            let socketKey = this.master.sockets.categories[conditional.action.override_target][0];
            this.master.sockets.entries[socketKey].override_cooldown(conditional.action.override_value);
        }
    }

    undo_conditional_action(conditional)
    {
        console.log("undo_conditional_action", conditional)
        if (conditional.action.type == 'grant')
        {
            this.dec_counter(conditional.action.grant_effect);
        }
        else if (conditional.action.type == 'override_ability')
        {
            console.log('here was rollback on remove');
            this.master.rollback_ability(conditional.action.override_target);
        }
        else if (conditional.action.type == 'override_ability_cooldown')
        {
            let socketKey = this.master.sockets.categories[conditional.action.override_target][0];
            this.master.sockets.entries[socketKey].rollback_cooldown();
        }
    }

    apply_effects()
    {
        console.log('APP/EFFECTS: Updating effects...');
        console.time('APP/EFFECTS: Effects updated');

        let sandbox = this.master.sandbox;
        let formulas = new Array();

        console.log('conditionally_active:', this.conditionally_active);

        for (let effect of this.conditionally_active)
        {
            if (this.master.check_condition(effect.activation_condition))
            {
                effect.is_active = true;
                this.active_effects.add(effect);
            }
            else
            {
                effect.is_active = false;
                this.active_effects.delete(effect);
            }
        }

        console.log('conditional_actions_list', this.conditional_actions_list);
        this.process_conditional_actions();

        console.log("List of active effects:");
        for (let effect of this.active_effects)
        {
            effect.reset(this.master.get_sandbox()); // restoring effect to its default state
            console.log("\t", effect.id);
        }

        // in percent
        let empowering_damage_buff = 1;
        let weapon_perk_damage_buff = 1;
        let weapon_surge_damage_buff = 1;

        //console.log('applying effects');
        for (let effect1 of this.active_effects) // applying effects to each other
        {
            for (let effect2 of this.active_effects)
            {
                if (effect1.id != effect2.id && is_intersect(effect1.relations, effect2.relations))
                {
                    console.log("|\t", effect1.id, '*', effect2.id);
                    effect1.apply(effect2, sandbox);
                }
            }
            // after all effects were applied to effect1 it reached its final state for this calculation round
            // do it is possible to apply it to other character attributes
            // so TODO: add changes to health, etc....

            for (let simple_value of effect1.get_simple_values(sandbox))
            {
                if (simple_value.get_type() == 'formula')
                {
                    formulas.push(simple_value);
                }

                if (simple_value.get_relates_to() == "empowering_damage_buff")
                {
                    let val = 1 + simple_value.get_value() / 100;

                    if (val > empowering_damage_buff)
                        empowering_damage_buff = val;
                }

                if (simple_value.get_relates_to() == "weapon_perk_damage_buff")
                {
                    weapon_perk_damage_buff *= 1 + simple_value.get_value() / 100;
                }

                if (simple_value.get_relates_to() == "weapon_surge_damage_buff")
                {
                    let val = 1 + simple_value.get_value() / 100;

                    if (val > weapon_surge_damage_buff)
                        weapon_surge_damage_buff = val;
                }
            }
        }

        console.log(`damage buffs:\nempowering_damage_buff: ${empowering_damage_buff}\nweapon_perk_damage_buff: ${weapon_perk_damage_buff}\nweapon_surge_damage_buff: ${weapon_surge_damage_buff} ` );

        // here formulas are updated
        console.log('APP/EFFCONT: formulas: ', formulas)
        for (let formula of formulas)
        {
            formula.set_value(this.master.calculate_formula(formula.get_default_value()));
        }
        //

        let total_damage_buff = empowering_damage_buff * weapon_perk_damage_buff * weapon_surge_damage_buff;
        console.log(`damage buffs:\n empowering_damage_buff: ${empowering_damage_buff}\n weapon_perk_damage_buff: ${weapon_perk_damage_buff}\n weapon_surge_damage_buff: ${weapon_surge_damage_buff} ` );

        console.log(`total damage buff: ${Math.round(total_damage_buff * 100 - 100)}%`, total_damage_buff);

        for (let effect of this.added_effects)
        {
            for (let simple_value of effect.get_simple_values(sandbox))
            {
                if (
                    simple_value.get_relates_to() == 'weapon_bodyshot_damage' ||
                    simple_value.get_relates_to() == 'weapon_crit_damage'
                )
                {
                    simple_value.set_value(simple_value.get_value() * total_damage_buff);
                }
            }
        }

        if (this.master.get_sandbox() == 'pve' && this.master.activity_id != null)
        {
            let mul = this.get(this.master.activity_id).total_multiplier;

            for (let effect of this.added_effects)
            {
                for (let simple_value of effect.get_simple_values(sandbox))
                {
                    if (
                        (
                            simple_value.get_relates_to() == 'charged_melee_damage' ||
                            simple_value.get_relates_to() == 'grenade_damage' ||
                            simple_value.get_relates_to() == 'grenade_melee_damage' ||
                            simple_value.get_relates_to() == 'super_damage' ||
                            simple_value.get_relates_to() == 'unspecified_ability_damage' ||
                            simple_value.get_relates_to() == 'weapon_bodyshot_damage' ||
                            simple_value.get_relates_to() == 'weapon_crit_damage'
                        ) && (simple_value.get_type() == 'stat' || simple_value.get_type() == 'formula')
                    )
                    {
                        simple_value.set_value(simple_value.get_value() * mul);
                    }
                }
            }
        }

        // updates
        this.commander.update(
            {
                update_type: "update_stats_colors",
                subclass_element: this.master.element,
            }
        );

        for (let effect of this.added_effects) // updating descriptions
        {
            if (effect.visibility != 'hidden' )
            {
                this.commander.update(
                    {
                        update_type: "update_effect_template",
                        effect_id: effect.id
                    }
                );
            }
        }
        console.timeEnd('APP/EFFECTS: Effects updated');

        this.update_cooldown_effect_lists();
    }

    update_cooldown_effect_lists()
    {
        console.log('remaking cooldown effect lists');
        this.sorted_by_duration = [];
        this.inf_duration = []

        for (let effect of this.affecting_cooldowns)
        {
            console.log("looking at", effect);
            if (effect.is_active && effect.active_duration == 'timer')
            {
                this.sorted_by_duration.push(effect);
                console.log('-> sorted_by_duration')
            }

            if (effect.is_active && effect.active_duration == 'infinite')
            {
                this.inf_duration.push(effect);
                console.log('-> inf_duration')
            }
        }

        this.sorted_by_duration.sort(function (a, b) {return a.get_duration() - b.get_duration()});
        console.log('dur effects', this.sorted_by_duration);
        console.log('inf effects', this.inf_duration);
    }

    get(value)
    {
        return this.effects.get(value);
    }

    set(key, value)
    {
        this.effects.set(key, value);
    }

    has(key)
    {
        return this.effects.has(key);
    }

    chain_add(effect)
    {
        if (effect.grants !== null) // adding granted effects
        {
            console.log('chain add:');
            for (let i in effect.grants)
            {
                this.inc_counter(effect.grants[i]);
            }
        }
    }

    chain_remove(effect)
    {
        if (effect.grants !== null) // removing granted effects
        {
            console.log('chain remove:');
            for (let i in effect.grants)
            {
                this.dec_counter(effect.grants[i], false);
            }
        }
    }
}
